import { VersionAssets } from "../../../redux/loadedContent/loadedContentSlice";
import axios from "../../apiFc24";

export const getVersionAssets = async () => {
  const res = await axios.get<VersionAssets>("/players/version-assets");
  return res.data;
};
